import { ArrowRight } from "lucide-react";
import { Reveal } from "../motion/Reveal";

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow flex items-center gap-4 ${className}`}>
    <span className="h-px w-8 bg-current opacity-60" aria-hidden="true" />
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, lines, className = "", dark = false, as: Tag = "h2" }) => (
  <Reveal className={className}>
    <Eyebrow>{eyebrow}</Eyebrow>
    <Tag className={`h-section mt-6 ${dark ? "text-[#F8F3E9]" : "text-[#26231F]"}`}>
      {lines.map((l) => <span key={l} className="block">{l}</span>)}
    </Tag>
  </Reveal>
);

export const LuxButton = ({ children, variant = "gold", arrow = false, className = "", ...rest }) => (
  <button type="button" className={`btn-${variant} ${className}`} {...rest}>
    <span>{children}</span>
    {arrow && <ArrowRight className="h-3.5 w-3.5" strokeWidth={1.6} aria-hidden="true" />}
  </button>
);
